import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

import HabitatFavorite from './HabitatFavorite';
import HabitatStatus from './HabitatStatus';
import style from './style.scss';

const BaseHabitatCard = ({
  className,
  online,
  liveTalk,
  image,
  logo,
  children,
  free = false,
  handleFavoriteClick,
  isLocked,
  isLogged,
  isFavorited,
  likeIcon,
  loading,
}) => {
  return (
    <div className={clsx(style.habitatCard, className)}>
      <div className={clsx(style.header, { [style.fallback]: !image })}>
        <HabitatStatus className={style.tag} online={online} liveTalk={liveTalk} free={free} />
        <div className={style.wideImage}>{image && <img src={image} alt="" />}</div>
        <div className={style.logo}>
          <img src={logo ?? 'https://zoolife.tv/assets/zooPlaceholder.webp'} alt="" />
        </div>
        {!isLocked && isLogged && (
          <HabitatFavorite
            className={style.fav}
            onClick={handleFavoriteClick}
            icon={likeIcon}
            color={isFavorited && !loading ? 'var(--pink)' : 'black'}
            spin={likeIcon === faSpinner}
            isFavorited={isFavorited}
          />
        )}
      </div>
      <div className={style.body}>{children}</div>
    </div>
  );
};

export default BaseHabitatCard;
